import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { PRIMARY_COLORS } from "../../consts/colors";

export const SignedOutStyleModal = styled(Modal)`
   .modal-content {
      font-family: "Roboto", "Helvetica Neue", sans-serif;
      border-top: none;
      border-radius: 0.25rem;
      .top-modal-border {
         width: 100%;
         height: 5px;
         background-color: ${PRIMARY_COLORS.FIRE_ENGINE_RED};
         border-radius: 0.5rem;
      }
      .modal-header {
         border-bottom: none;
      }
   }
   &.desktop-css {
      .modal-body {
         margin: 0px 20px 20px 20px;
      }
   }
  .message-content {
    display: flex;
    align-items: center;
    text-align: center;
    margin-bottom: 20px;
  }
  .buttons-section {
    align-items: center;
    text-align: center;
  }
  .signed-out-button {
    width: 70px;
  }
`;

export const SignedOutModalHeader = styled.header`
   &.mobile-header-css {
      margin-bottom: 0px;
   }
   &.desktop-header-css {
      margin-bottom: 20px;
   }
   display: flex;
   justify-content: center;
`;
